import React from "react";

import { ComponentLayout } from "../../support/ComponentLayout";
import { ComponentSectionLayout } from "../../support/ComponentSectionLayout";

export const FormTextAreasDemo: React.FC<unknown> = () => {
  return (
    <ComponentLayout title={"Wip - Form Textareas"}>
      <ComponentSectionLayout title={"default"}></ComponentSectionLayout>
    </ComponentLayout>
  );
};
